import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ROLES } from '../constants/roles.constants';

export const RekbotGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);

    if(authService.user === null) {
        return false;
    }

    return authService.user.role!.role_id > ROLES.admin;
    
};
